<template>
    <div style="height:100%;width:100%;position:fixed;left:0;top:0;" id="map"></div>
</template>
<script>
export default {
    data() {
        return {
            loading: false,
            row: {},
        }
    },
    mounted() {
        const urlParams = new URLSearchParams(window.location.search);
        const NO = urlParams.get('NO');
        if (!NO) {
            this.$msg('参数错误', 'error');
            return false;
        };
        this.initMap();
        this.getElectronicbillDetailed(NO);
    },

    methods: {
        // +----------------------------------------------------------------------
        // | 详情
        // +----------------------------------------------------------------------
        getElectronicbillDetailed(NO) {
            this.loading = true;
            var parameter = { NO: NO };
            this.$loading(true);
            this.$api.getElectronicbillDetailed(parameter).then((res) => {
                this.loading = false;
                this.$loading(false);
                if (res.code == 0) {
                    this.row = res.data;
                    this.QQmap(res.data.route);
                } else {
                    this.$msg(res.msg, "error");
                };
            });
        },

        // +----------------------------------------------------------------------
        // | 绘制腾讯地图
        // +----------------------------------------------------------------------
        initMap() {
            // 初始化地图
            this.map = new TMap.Map(document.getElementById('map'), {
                center: new TMap.LatLng(23.109022, 113.264944), // 地图中心坐标
                zoom: 16, // 地图缩放级别
                showControl:false,
                mapStyleId: 'style1',
            });
        },
        drawPath(coordinates) {
            //创建 MultiPolyline显示折线
            var polylineLayer = new TMap.MultiPolyline({
                id: 'polyline-layer', //图层唯一标识
                map: this.map, //绘制到目标地图
                //折线样式定义
                styles: {
                    'style_blue': new TMap.PolylineStyle({
                        'color': '#3777FF', //线填充色
                        'width': 8, //折线宽度
                        'borderWidth': 5, //边线宽度
                        'borderColor': '#FFF', //边线颜色
                        'lineCap': 'round', //线端头方式
                    })
                },
                //折线数据定义
                geometries: [{
                    'id': 'pl_1', //折线唯一标识，删除时使用
                    'styleId': 'style_blue', //绑定样式名
                    'paths': coordinates
                }]
            });
        },
        QQmap(mapJson) {
            //格式化路线
            var mapJson = JSON.parse(mapJson);
            
            var coords = mapJson['result']['routes']['0']['polyline'];
            var pl = [];
            var kr = 1000000;
            for (var i = 2; i < coords.length; i++) {
                coords[i] = Number(coords[i - 2]) + Number(coords[i]) / kr;
            }
            for (var i = 0; i < coords.length; i += 2) {
                pl.push(new TMap.LatLng(coords[i], coords[i + 1]));
            };

            //计算此路线的中心点
            const firstPoint = pl[0];
            const lastPoint = pl[pl.length - 1];
            const midLat = (firstPoint.lat + lastPoint.lat) / 2;
            const midLng = (firstPoint.lng + lastPoint.lng) / 2;
            const midPoint = new TMap.LatLng(midLat, midLng);
            this.map.setCenter(midPoint);
            console.log(firstPoint);
            console.log(lastPoint);

            //标记起终点marker
            var marker = new TMap.MultiMarker({
                id: 'marker-layer',
                map: this.map,
                styles: {
                    "start": new TMap.MarkerStyle({
                        "width": 25,
                        "height": 35,
                        "anchor": {
                            x: 16,
                            y: 32
                        },
                        "src": require('@/configOs/img/start.png')
                    }),
                    "end": new TMap.MarkerStyle({
                        "width": 25,
                        "height": 35,
                        "anchor": {
                            x: 16,
                            y: 32
                        },
                        "src": require('@/configOs/img/end.png')
                    })
                },
                geometries: [{
                    "id": 'start',
                    "styleId": 'start',
                    "position": firstPoint
                }, {
                    "id": 'end',
                    "styleId": 'end',
                    "position": lastPoint
                }]
            });

            //调用绘制折线
            this.drawPath(pl);
        },
    }
}
</script>
<style>
.electronicbilldetailed {
    max-width: 210mm;
    margin: 0 auto;
    display: block;
}

.electronicbilldetailed td {
    color: #333;
    padding: 6px 10px !important;
}

.electronicbilldetailed .headA {
    text-align: center;
    color: #fff !important;
    font-weight: 700 !important;
    font-size: 18px !important;
    background: #3975C6;
    position: relative;
}


.electronicbilldetailed .contentB {
    background: #F9F9F9;
}

.QHtable td {
    border-color: #eee;
}

html,
body {
    min-width: 0;
    min-height: 0;
    height: auto !important;
    overflow-x: hidden !important;
    overflow-y: auto !important;
}
</style>